// styled-components based extension
import styled from 'styled-components'

const Target = styled.a`
  line-height: 1.55;
  display: flex;
  ${props => props.disabled && `
    cursor: not-allowed;
  `}
`

Target.defaultProps = {
  as: 'a',
  color: 'greyDark',
  fontSize: 1,
}

export default Target